import config from '../../configs/client';

const translations = Object.assign(
    {},
    require(`./${config.lang}/placeholders`),
    require(`./${config.lang}/tips`),
    require(`./${config.lang}/validation`),
    require(`./${config.lang}/warnings`),
    require(`./${config.lang}/text`),
    require(`./${config.lang}/success`),
    require(`./${config.lang}/units`),
);

export function translate(key, context) {
    const translation = translations[key];

    if (context && translation && translation[context]) {
        return translation[context];
    }

    return (translation && translation.default || translation) || key;
}



// WEBPACK FOOTER //
// ./client/lang/index.js